module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/tiktok-white-02340e0f929d9fd9969ee9a794601d2e.svg";